import React, { useState, useEffect } from "react";
import { FormRow, FormRowInner, Label, ReadOnly, CanEdit, Note, DatePickerWrapper } from "../../../styles/forms/inputs";
import InputError from "../errors/input";
import DatePicker from "react-datepicker";
import moment from "moment";
import { EventTargetType } from "../../../_types/form";
import InputHelp from "./help";
import { IHelp } from "../../../state/context/modals.reducers";

type Props = {
	label?: string;
	light?: boolean;
	help?: IHelp;
	placeholder?: string;
	name: string;
	value: string;
	readonly?: boolean;
	error?: string;
	inline?: boolean;
	onChange: (e: EventTargetType) => void;
	required?: boolean;
	canEditReadOnly?: boolean;
	note?: string;
	min?: number | string;
	max?: number | string;
	minDate?: Date;
	maxDate?: Date;
};

const DateInput: React.FC<Props> = ({ label, light, help, placeholder, name, value, readonly, error, inline, onChange, required, canEditReadOnly = null, note, min, max, minDate, maxDate }) => {
	const [inputValue, setInputValue] = useState(
		value && moment(value, ["YYYY-MM-DD", "DD/MM/YYYY", "MM/DD/YYYY", "YYYY/MM/DD", "DD-MM-YYYY", "DD.MM.YYYY", "YYYY.MM.DD"]).isValid()
			? moment(value, ["YYYY-MM-DD", "DD/MM/YYYY", "MM/DD/YYYY", "YYYY/MM/DD", "DD-MM-YYYY", "DD.MM.YYYY", "YYYY.MM.DD"]).toDate()
			: ""
	);

	useEffect(() => {
		const newValue =
			value && moment(value, ["YYYY-MM-DD", "DD/MM/YYYY", "MM/DD/YYYY", "YYYY/MM/DD", "DD-MM-YYYY", "DD.MM.YYYY", "YYYY.MM.DD"]).isValid()
				? moment(value, ["YYYY-MM-DD", "DD/MM/YYYY", "YYYY/MM/DD", "DD-MM-YYYY", "DD.MM.YYYY", "YYYY.MM.DD"]).toDate()
				: "";

		if (newValue !== inputValue) {
			setInputValue(newValue);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [value]);

	const [inputError, setInputError] = useState(error);
	const [isReadOnly, setReadOnly] = useState(readonly);

	const handleChange = (dateString: string) => {
		setInputValue(moment(dateString).isValid() ? moment(dateString).toDate() : "");
		onChange({
			target: {
				name,
				value: moment(dateString).isValid() ? moment(dateString).format("YYYY-MM-DDT00:00:00") : "",
			},
		});
	};

	useEffect(() => {
		setInputError(error);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [error]);

	useEffect(() => {
		if (readonly !== isReadOnly) setReadOnly(readonly);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [readonly]);

	useEffect(() => {
		if (canEditReadOnly !== null && !canEditReadOnly) setReadOnly(true);
	}, [canEditReadOnly]);

	return (
		<FormRow hasError={inputError ? true : false}>
			<FormRowInner readonly={isReadOnly}>
				{label && (
					<Label light={light ? true : false} help={help}>
						{label}
						{required ? "*" : null}
						{help ? <InputHelp help={help} /> : null}
					</Label>
				)}
				{note && <Note>{note}</Note>}
				{isReadOnly ? (
					<ReadOnly canEdit={canEditReadOnly}>
						{inputValue ? (moment(inputValue).isValid() ? moment(inputValue).format("DD/MM/YYYY") : "") : ""}
						{canEditReadOnly ? <CanEdit onClick={() => setReadOnly(!isReadOnly)} /> : null}
					</ReadOnly>
				) : (
					<DatePickerWrapper>
						<DatePicker
							selected={inputValue && moment(inputValue).isValid() ? new Date(inputValue) : ""}
							onChange={(date) => handleChange(date)}
							dateFormat="dd/MM/yyyy"
							showMonthDropdown
							showYearDropdown
							dropdownMode="select"
							minDate={minDate ? minDate : undefined}
							maxDate={maxDate ? maxDate : undefined}
						/>
					</DatePickerWrapper>
				)}
			</FormRowInner>
			{!inputError ? null : <InputError message={inputError} inline={inline} />}
		</FormRow>
	);
};
export default DateInput;
